import styled from 'styled-components'

export const TextInfo = styled.p`
  font-size: 16px;
  font-weight: 500;
`
